













import { Component, Vue, Prop } from 'vue-property-decorator';
import ChatComment from '@/components/Chat/ChatComment.vue';
import ChatMessage from '@/components/Chat/ChatMessage.vue';

@Component({
    components: {
        ChatMessage,
        ChatComment,
    },
})
export default class ChatBody extends Vue {
    @Prop({default: 'conversation'}) public type: string;
    @Prop({default: false}) public forceDeleteMessages: boolean;
    @Prop({default: []}) public messages: any;

    get component() {
        return this.type === 'conversation' ? 'ChatMessage' : 'ChatComment';
    }
}
